import Swal from 'sweetalert2'
import { COLOR_APP } from '../constants'

export const successSwal = (item) => {
    Swal.fire({
        icon: 'success',
        title: item,
        showConfirmButton: false,
        timer: 1800
    })
}
export const successUpdateSwal = (item) => {
    Swal.fire({
        icon: 'success',
        title: item,
        showConfirmButton: false,
        timer: 1800
    })
}
export const successDeleteSwal = (item) => {
    Swal.fire({
        icon: 'success',
        title: item,
        showConfirmButton: false,
        timer: 1800
    })
}
export const errorSwal = (text, icon) => {
    Swal.fire({
        icon: icon ? icon : 'error',
        title: "ມີບາງຢ່າງຜິດພາດ",
        text: text ? text : "ຂໍ້ມູນລົ້ມແຫຼວ",
        showConfirmButton: false,
        timer: 7000
    })
}


export const errorTitleWithTextSwal = (title, text) => {
    Swal.fire({
        icon: 'error',
        title,
        text,
        showConfirmButton: false,
        timer: 5000
    })
}

export const errorPermissionTitleWithTextSwal = (title, text) => {
    Swal.fire({
        icon: 'error',
        title,
        text,
        showConfirmButton: false,
        focusDeny: false,
        focusCancel: false,
        returnFocus: false,
        showCloseButton: true
    })
}

export const wariningWithTextAndConfirmButton = (title, detail, onConfirm) => {
    Swal.fire({
        title: title,
        text: detail,
        icon: 'success',
        timer: 5000
    }).then(async () => {
        try {
            await onConfirm()
        } catch (error) {
            console.log("Error: ", error)
        }
    })
}

// ແຈ້ງສຳເລັດໃນ flow checkout — ໃຊ້ຊຸດ style ດຽວກັບ requestionFields
// ບໍ່ໃສ່ປຸ່ມ ແລະ ປິດເອງໃນ 1.6 ວິ ເພາະຂ່າວດີບໍ່ຄວນບັງຄັບໃຫ້ລູກຄ້າກົດເພີ່ມ 1 ເທື່ອ
export const successFields = ({ text }) => {
    Swal.fire({
        icon: "success",
        title: text ?? "ສຳເລັດ",
        showConfirmButton: false,
        timer: 1600,
        customClass: {
            popup: "cf-swal",
            title: "cf-swal__title",
            icon: "cf-swal__icon",
        },
    });
}

// ແຈ້ງຜິດພາດໃນ flow checkout — ຊຸດ style ດຽວກັບ successFields/requestionFields
// ໃສ່ປຸ່ມແທນ timer ເພາະຂໍ້ຜິດພາດຕ້ອງໃຫ້ລູກຄ້າອ່ານຈົບກ່ອນ ບໍ່ຄວນຫາຍໄປເອງ
export const errorFields = ({ text }) => {
    Swal.fire({
        icon: "error",
        title: text ?? "ເກີດຂໍ້ຜິດພາດ",
        confirmButtonText: "ເຂົ້າໃຈແລ້ວ",
        buttonsStyling: false,
        customClass: {
            popup: "cf-swal",
            title: "cf-swal__title",
            icon: "cf-swal__icon",
            actions: "cf-swal__actions",
            confirmButton: "cf-btn cf-btn--primary",
        },
    });
}

// ໃຊ້ໃນ flow checkout ເທົ່ານັ້ນ — class cf-* ມາຈາກ checkout-theme.css
// icon ເປັນ warning ບໍ່ແມ່ນ error ເພາະນີ້ຄືການເຕືອນວ່າຂໍ້ມູນຍັງບໍ່ຄົບ ບໍ່ແມ່ນລະບົບພັງ
// ຕັດ timer ອອກ ໃສ່ປຸ່ມແທນ — ຂໍ້ຄວາມທີ່ລູກຄ້າຕ້ອງລົງມືແກ້ ບໍ່ຄວນຫາຍໄປເອງໃນ 4 ວິນາທີ
export const requestionFields = ({text}) => {
    Swal.fire({
        icon: "warning",
        title: text ?? "ກະລຸນາປ້ອນຂໍ້ມູນກ່ອນ",
        confirmButtonText: "ເຂົ້າໃຈແລ້ວ",
        buttonsStyling: false,
        customClass: {
            popup: "cf-swal",
            title: "cf-swal__title",
            icon: "cf-swal__icon",
            actions: "cf-swal__actions",
            confirmButton: "cf-btn cf-btn--primary",
        },
      });
}
